import { useMemo } from 'react';
import { object, string } from 'yup';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { ITokenizedCardSelectorData } from '../ITokenizedCardSelectorData';

export function useTokenizedCardSelectorSchema() {
	const { t } = useTranslation();

	return useMemo(
		() =>
			object<ITokenizedCardSelectorData>({
				tokenizedCardId: string().required(t('web_mandatory_field_error')),
			}).required(),
		[],
	);
}
